import HttpService from '../HttpService'

export default class MailTemplateService {
  constructor() {
    this._httpService = new HttpService('odoo')
  }

  async FindAllBackend() {
    return await this._httpService.get('/mail-template/backend')
  }

  async FindById(id) {
    return await this._httpService.get(`/mail-template/${id}`)
  }
}
